(function availableHomesSortByModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.AvailableHomesSortBy = global.NewHomeSource.AvailableHomesSortBy || {};

  const filterKeys = {
    Bedrooms: 'BD',
    Bathrooms: 'BA',
    PriceHighToLow: 'H',
    PriceLowToHigh: 'L',
    Default: 'S' // Original order
  };
  Object.freeze(filterKeys); // Prevent modification of filterKeys

  let mostRecentSortBy = filterKeys.Default; // Default to original order

  /**
   * Helper to get the data-value
   *
   * @param {any} card - listing card
   * @param {any} attr - data attribute
   * @returns {number} - data value as a number
   */
  const getValue = (card, attr) => {
    let value = card.getAttribute(attr);
    if (value === null) {
      return 0;
    }
    if (attr === 'data-price') {
      // Remove $ and , before parsing
      if (typeof value === 'string') {
        value = value.replace(/[$,]/g, '');
      }
      return parseFloat(value) || 0;
    }
    if (attr === 'data-bedrooms' || attr === 'data-bathrooms') {
      return parseFloat(value) || 0;
    }
    return value;
  };

  /**
   * Helper to sort cards in a container
   *
   * @function
   * @returns {string} - most recent sort type
   */
  const sortCards = (containerId, sortBy) => {
    const container = document.getElementById(containerId);
    if (!container) {
      return mostRecentSortBy;
    }

    // Count currently visible cards (not hidden)
    const visibleCount = Array.from(container.children).filter((card) => !card.hidden).length;

    let sortedCards;
    switch (sortBy) {
      case filterKeys.PriceLowToHigh: // Price Low to High
        sortedCards = Array.from(container.children)
          .sort((a, b) => getValue(a, 'data-price') - getValue(b, 'data-price'));
        mostRecentSortBy = filterKeys.PriceLowToHigh;
        break;
      case filterKeys.PriceHighToLow: // Price High to Low
        sortedCards = Array.from(container.children)
          .sort((a, b) => getValue(b, 'data-price') - getValue(a, 'data-price'));
        mostRecentSortBy = filterKeys.PriceHighToLow;
        break;
      case filterKeys.Bedrooms: // Bedrooms
        sortedCards = Array.from(container.children)
          .sort((a, b) => getValue(b, 'data-bedrooms') - getValue(a, 'data-bedrooms'));
        mostRecentSortBy = filterKeys.Bedrooms;
        break;
      case filterKeys.Bathrooms: // Bathrooms
        sortedCards = Array.from(container.children)
          .sort((a, b) => getValue(b, 'data-bathrooms') - getValue(a, 'data-bathrooms'));
        mostRecentSortBy = filterKeys.Bathrooms;
        break;
      default: // Original order
        sortedCards = Array.from(container.children)
          .sort((a, b) => getValue(a, 'data-index') - getValue(b, 'data-index'));
        mostRecentSortBy = filterKeys.Default;
        break;
    }

    // Hide all cards first, then show only the first visibleCount cards, and re-append in sorted order
    sortedCards.forEach((card, i) => {
      const thisCard = card;
      thisCard.hidden = true;
      if (i < visibleCount) {
        thisCard.hidden = false;
      }
      container.appendChild(thisCard);
    });

    requestAnimationFrame(() => {
      container.scroll({
        left: 0,
        behavior: 'smooth'
      }); // Reset scroll position to the start
    });

    return mostRecentSortBy;
  };

  // Expose to global for use in other scripts
  global.NewHomeSource.AvailableHomesSortBy.sortCards = sortCards;
  Object.defineProperty(global.NewHomeSource.AvailableHomesSortBy, 'mostRecentSortBy', {
    get() { return mostRecentSortBy; }
  });

  // Named event handler to allow removal and prevent duplicates
  const sortByChangeHandler = (event) => {
    const sortSelect = event.target;
    const sortByValue = sortSelect.value;
    sortCards('plans-container', sortByValue);
    sortCards('specs-container', sortByValue);
  };

  /**
  * Initializes the sort by functionality for available homes.
  *
  * @function
  * @returns {void}
  */
  const handleSortBySelect = () => {
    const sortSelect = document.getElementById('availhomes-sortby');
    if (!sortSelect) {
      return;
    }
    // Remove previous handler if it exists to prevent duplicates
    sortSelect.removeEventListener('change', sortByChangeHandler);
    sortSelect.addEventListener('change', sortByChangeHandler);
  };

  handleSortBySelect();
}(window));
